import { render } from "./Footer.vue?vue&type=template&id=25bd0575&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=25bd0575&scoped=true&lang=scss"
import "./Footer.vue?vue&type=style&index=1&id=25bd0575&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25bd0575"]])

export default __exports__